import Home from './Home';
import Setup from './Setup';
import Entry from './Entry';
import Schedule from './Schedule';
import WeighIn from './WeighIn';

const pages = [Home, Setup, Entry, Schedule, WeighIn];

export default pages;



// WEBPACK FOOTER //
// ./src/pages/index.js